// EmptyState - 列表/页面空状态
// v1.9 P0: 用 Card 包 + Icon 替代 emoji + Spinner fallback
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon, type IconSize } from './Icon';
import { Card } from './ui/Card';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  iconSize?: IconSize;
  className?: string;
}

export function EmptyState({
  icon = 'circle',
  title,
  description,
  action,
  iconSize = 'xl',
  className,
}: EmptyStateProps) {
  return (
    <Card
      padding="lg"
      className={twMerge(
        'border-dashed border-2 border-line text-center animate-fade-up',
        className,
      )}
    >
      <div className="flex flex-col items-center gap-2 py-2">
        <div className="w-12 h-12 rounded-full bg-surface-2 flex items-center justify-center text-ink-3">
          <Icon name={icon} size={typeof iconSize === 'number' ? 'lg' : iconSize} aria-hidden />
        </div>
        <p className="text-sm font-medium text-ink-2 mt-1">{title}</p>
        {description && (
          <p className="text-xs text-ink-3 max-w-sm leading-relaxed">{description}</p>
        )}
        {action && <div className="mt-3">{action}</div>}
      </div>
    </Card>
  );
}
